<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import NotificationBase from '../../../notifications/components/NotificationBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <NotificationBase />
</template>